export const settings = {
  title: 'Settings',
  shortcut: 'command+shift+,',
  run: () => {
    window.open('/settings');
    return null;
  },
};



// WEBPACK FOOTER //
// ./src/lib/commands/settings.js